import { connect } from "react-redux";
import * as actions from "./actions";
import { invocate, changePath } from "../Wizard/actions";
import WidgetSelectionStep from "../../components/WidgetSelectionStep";
import { WizardProps } from "../Wizard";
import { WidgetSelectionStepReducer } from "./reducer";

export type WidgetReducerProps = {
  widgetSelectionStep: WidgetSelectionStepReducer;
  wizard: WizardProps;
};

const mapStateToProps = ({ widgetSelectionStep, wizard }: WidgetReducerProps) => ({
  loading: widgetSelectionStep.loading,
  widgets: widgetSelectionStep.widgets,
  invocations: wizard.invocations,
});

export default connect(mapStateToProps, { invocate, changePath, ...actions })(
  WidgetSelectionStep,
);
